<template>
  <div class="track-scene" :class="{'is-active': scene === selection.scene}">
    <slot />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'track-scene',
    props: ['scene'],
    computed: {
      ...mapState(['video', 'selection'])
    }
  }

</script>
